import React from 'react';
import './CalendarCompletedMark.css';

export function CalendarCompletedMark() {
  return <span className="calendar-completed-mark" aria-hidden="true">
    <svg viewBox="0 0 12 12" fill="none" focusable="false">
      <path d="m3 6 2 2 4-4" />
    </svg>
  </span>;
}

export function CalendarPlannedMark({ missed = false }: { missed?: boolean }) {
  return <span className={`calendar-planned-mark${missed ? ' calendar-planned-mark--missed' : ''}`} aria-hidden="true">
    {missed && <svg viewBox="0 0 12 12" fill="none" focusable="false">
      <path d="m4 4 4 4m0-4-4 4" />
    </svg>}
  </span>;
}
